import { render, staticRenderFns } from "./FileUploadModule.vue?vue&type=template&id=25b81ace&scoped=true&"
import script from "./FileUploadModule.vue?vue&type=script&lang=js&"
export * from "./FileUploadModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b81ace",
  null
  
)

export default component.exports